export default __webpack_public_path__ + "assets/06566fe0b7c57f5d1fc3730b1cbaffc3.png";